/**
 * @generated SignedSource<<2cbdf9a0e2edb51c44bad350e0590740>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GenerateUniquePrefixInput = {
  name?: string | null;
  domain?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type generateUniquePrefixMutation$variables = {
  input: GenerateUniquePrefixInput;
};
export type generateUniquePrefixMutation$data = {
  readonly generateUniquePrefix: {
    readonly prefix: string | null;
  } | null;
};
export type generateUniquePrefixMutation = {
  variables: generateUniquePrefixMutation$variables;
  response: generateUniquePrefixMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateUniquePrefixPayload",
    "kind": "LinkedField",
    "name": "generateUniquePrefix",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "prefix",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "generateUniquePrefixMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "generateUniquePrefixMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bc7ea0cb7ae251f80b3be3d0730f9894",
    "id": null,
    "metadata": {},
    "name": "generateUniquePrefixMutation",
    "operationKind": "mutation",
    "text": "mutation generateUniquePrefixMutation(\n  $input: GenerateUniquePrefixInput!\n) {\n  generateUniquePrefix(input: $input) {\n    prefix\n  }\n}\n"
  }
};
})();

(node as any).hash = "a76f71f64bea2de03b50316f27bec514";

export default node;
